import { render } from "./ViewBescPricingRulePage.vue?vue&type=template&id=1ac7420c&ts=true"
import script from "./ViewBescPricingRulePage.vue?vue&type=script&lang=ts"
export * from "./ViewBescPricingRulePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__